import VideoSubmissionItem from "./VideoSubmissionItem";

export default VideoSubmissionItem;
